module.exports = __webpack_public_path__ + "img/database.e879228b.png";